// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.inline-message[data-v-206831f6] {
  margin-bottom: 8px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 12px 16px;
  width: 94%;
  background: #fff5d6;
  border-radius: 16px;
  box-sizing: border-box;
}
.inline-message__content[data-v-206831f6] {
  display: flex;
  width: 100%;
  gap: 12px;
  align-items: center;
}
.inline-message__icon[data-v-206831f6] {
  flex-shrink: 0;
}
.inline-message__text[data-v-206831f6] {
  flex: 1;
  color: #333333;
  font-size: 14px;
  line-height: 1.4;
}
.inline-message__body[data-v-206831f6] {
  font-weight: 400;
  font-size: 12px;
  size: 12px;
  letter-spacing: 0px;
  line-height: 18px;
}
.inline-message__action[data-v-206831f6] {
  margin-top: 4px;
}
.inline-message__link[data-v-206831f6] {
  color: #4fa58c;
  text-decoration: none;

  font-family: Jost;
  font-weight: 500;
  font-size: 12px;
  line-height: 18px;
  letter-spacing: 0px;
}
.inline-message__link[data-v-206831f6]:hover {
  text-decoration: underline;
}
`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
